import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ptTranslation from './locales/pt/translation.json';
import esTranslation from './locales/es/translation.json';
import enTranslation from './locales/en/translation.json';

const resources = {
  pt: { translation: ptTranslation },
  es: { translation: esTranslation },
  en: { translation: enTranslation }
};

// Get saved language or default to Portuguese
const getSavedLanguage = () => {
  const saved = localStorage.getItem('i18nextLng');
  // Only return saved language if it's one of our supported languages
  if (saved && ['pt', 'es', 'en'].includes(saved)) {
    return saved;
  }
  return 'pt'; // Default to Portuguese
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getSavedLanguage(), // Use saved language or default to Portuguese
    fallbackLng: 'pt',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
